<template>
	<div class="ReBPTaskEdit">
		<!--
		<h5>ReBPTaskEdit</h5>
		{{taskId}}
		{{operationType}}
		{{SGVO.GetGetVar('stage_id')}}
		-->
		<card>
			<ReFormPrinter 
				:masFormConfig="masAllFormParams" 
				:objSaveApiMethod="currentApiFormMethod"
				:SuccessGo="SuccessGo"/>
		</card>

		<card>
			<ReFormPrinter 
				:masFormConfig="masAllFormParamsTags" 
				:objSaveApiMethod="currentApiFormMethodTags"
				:SuccessGo="SuccessGo"/>
		</card>
	</div>
</template>

<script>
	import ReFormPrinter from 'src/our_components/FormPrinter/ReFormPrinter.vue';
	export default {
		name: 'ReBPTaskEdit',
		components: {
			ReFormPrinter
		},
		props: {
			taskId: {
				type: String, 
				default: '-1'
			},
			operationType: String, 
		},
		data () {
			return {
				ver: 1,
				masAllFormParams: this.currentFormConfig(),
				masAllFormParamsTags: this.currentFormConfigTags(),
			}
		},
		computed: {
			currentApiFormMethod: function(){
				if(this.operationType == 'edit'){
					return {apiMethod:'UPD_TASK',apiParam:{obj:'BP' ,flt:{id:this.taskId},uData:[]}};
				} else if(this.operationType == 'add'){
					return {apiMethod:'ADD_TASK',apiParam:{obj:'BP' ,flt:{BP_ID:this.$route.params.bp_id,STAGE_ID:this.$GVO.GetGetVar('stage_id')},iData:[]}};
				}
				return {apiMethod:'UPD_TASK',apiParam:{obj:'BP' ,flt:{id:this.taskId},uData:[]}};
			},
			currentApiFormMethodTags: function(){
				/*
				if(this.operationType == 'edit'){
					return {apiMethod:'BP.INS_BP_TASKS_TAGS',apiParam:{flt:{id:this.taskId},iData:[]}};
				} else if(this.operationType == 'add'){
					return {apiMethod:'BP.INS_BP_TASKS_TAGS',apiParam:{flt:{id:this.taskId},iData:[]}};
				}
				*/
				return {apiMethod:'BP.INSUPD_BP_TASKS_TAGS',apiParam:{flt:{id:this.taskId},iData:[]}};
			}
		},
		methods: {
			currentFormConfig(){
				if(this.operationType == 'edit'){
					this.$GVO.ApiCall('GET_FORM_TASK',{obj:'BP',flt:{id:this.taskId}})
						.then((objApi) => {
							//console.log('currentFormConfig',objApi);
							if(objApi.success){
								for (let i = 0; i < objApi.config[1].elements.length; i++) {
									const element = objApi.config[1].elements[i];
									if(element.elementType == 'task-ends'){
										for (let x = 0; x < element.element_model.length; x++) {
											const te = element.element_model[x];
											if(typeof te.transfer_result != 'undefined' && te.transfer_result.indexOf(',')>-1){
												let arrDMP = objApi.config[1].elements[i].element_model[x].transfer_result.split(',');
												objApi.config[1].elements[i].element_model[x].transfer_result = [];
												for (let z = 0; z < arrDMP.length; z++) {
													if(arrDMP[z] != '')objApi.config[1].elements[i].element_model[x].transfer_result.push(arrDMP[z]);
												}
												//console.log(objApi.config[1].elements[i].element_model[x].transfer_result);
											}
										}
									}
								}
								this.masAllFormParams = objApi.config;
							}
						})
						.catch(errorObjApi => console.error(errorObjApi));
				} else if(this.operationType == 'add' && typeof this.$GVO.GetGetVar('stage_id') != 'undefined'){
					this.$GVO.ApiCall('GET_FORM_TASK',{obj:'BP',flt:{'BP_ID':this.$route.params.bp_id,'STAGE_ID':this.$GVO.GetGetVar('stage_id')}})
						.then((objApi) => {
							//console.log(objApi);
							if(objApi.success){
								this.masAllFormParams = objApi.config;
							}
						})
						.catch(errorObjApi => console.error(errorObjApi));
				}
				return [];
			},
			currentFormConfigTags(){
				this.$GVO.ApiCall('BP.GET_FORM_MODEL_BP_TASKS_TAGS',{flt:{result_id:this.taskId}})
					.then((objApi) => {
						//console.log('currentFormConfigTags',objApi);
						if(objApi.success){
							this.masAllFormParamsTags = objApi.config;
						}
					}).catch(errorObjApi => console.error(errorObjApi));
				return [];
			},
			SuccessGo(evt){
				if(this.operationType == 'edit'){
					this.$router.push({path: this.$GVO.str_replace('/edit/task/'+this.taskId,'',evt)});
				} else if(this.operationType == 'add'){
					this.$router.push({path: this.$GVO.str_replace('/add/task','',evt)});
				}
			},
		},
	}
</script>
<style scoped>

.ReBPTaskEdit >>> #act {display: none;}

</style>
